module.exports = __webpack_public_path__ + "fonts/Muli-SemiBold.8b517aa1.ttf";